import { NgtUniversalModule } from '@ng-toolkit/universal';
import { CommonModule } from '@angular/common';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { HomeModule } from './home/home.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRouting } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { MatToolbarModule } from '@angular/material/toolbar'
import { HttpClientModule } from '@angular/common/http';
// import { MatCardModule } from '@angular/material/card'
// import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu';

import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
  LinkedInLoginProvider,
} from 'angularx-social-login';
// import { SignInComponent } from './dialogs/sign-in/sign-in.component';
// import { ThankYouDialogComponent } from './dialogs/thank-you-dialog/thank-you-dialog.component';
// import { MatDialogModule } from '@angular/material/dialog'
import { SharedModule } from './shared/shared.module';
// import { MatChipsModule } from '@angular/material/chips'
import { MatNativeDateModule } from '@angular/material';
import { PreloadSelectedModulesList } from './app-preloading';

const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(
      '814821459166-uh2anc0kg2tot0uf5n7n29fv8foogi2n.apps.googleusercontent.com'
    ),
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('238604546585672'),
  },
  {
    id: LinkedInLoginProvider.PROVIDER_ID,
    provider: new LinkedInLoginProvider('81vl95zfoimc37', false, 'en_US'),
  },
]);

export function provideConfig() {
  return config;
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    NgtUniversalModule,
    TransferHttpCacheModule,
    HttpClientModule,
    AppRouting,
    BrowserAnimationsModule,
    HomeModule,
    SocialLoginModule,
    HttpClientModule,
    MatNativeDateModule,
    SharedModule,
    MatMenuModule,
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig,
    },
    PreloadSelectedModulesList,
  ],
})
export class AppModule {}
